import { appName } from '../config'
import { cities } from "../data/cities";
import { randomNumber } from "../helpers/helpers";

/**
 * Constants
 * */

export const moduleName = 'cities'
const prefix = `${appName}/${moduleName}`
export const RANDOM_CITY_REQUEST = `${prefix}/RANDOM_CITY_REQUEST`
export const NEXT_CITY_REQUEST = `${prefix}/NEXT_CITY_REQUEST`
export const PREV_CITY_REQUEST = `${prefix}/PREV_CITY_REQUEST`
export const CITY_BY_ID_REQUEST = `${prefix}/CITY_BY_ID_REQUEST`

export const randomArray = [ ...Array.apply(null, {length: cities.length}).map(Number.call, Number), ...Array.apply(null, {length: 13}).map(Number.call, Number) ]

/**
 * Reducer
 * */
const defaultState = null

export const citiesReducer = (state = defaultState, action) => {
  switch (action.type) {
    case RANDOM_CITY_REQUEST:
      const random = randomNumber(0, randomArray.length)
      const index = randomArray[random]
      return { ...state, ...cities[index], id: index }

    case NEXT_CITY_REQUEST:
      const next =  state.id < cities.length - 1 ?  state.id + 1 : 0
      return { ...state, ...cities[next], id: next }

    case PREV_CITY_REQUEST:
      const prev = state.id > 0 ? state.id - 1 : cities.length - 1
      return { ...state, ...cities[prev], id: prev }

    case CITY_BY_ID_REQUEST:
      return { ...state, ...cities[action.payload], id: action.payload }

    default:
      return state
  }
}

/**
 * Selectors
 * */

/**
 * Action Creators
 * */

export const getRandomCity = () => {
  return {
    type: RANDOM_CITY_REQUEST
  }
}
export const getNextCity = () => {
  return {
    type: NEXT_CITY_REQUEST
  }
}
export const getPrevCity = () => {
  return {
    type: PREV_CITY_REQUEST
  }
}

export const getCityById = (id) => {
  return {
    type: CITY_BY_ID_REQUEST,
    payload: id
  }
}




// WEBPACK FOOTER //
// ./src/ducks/cities.js